import { render, staticRenderFns } from "./GlobalCouponDisplay.vue?vue&type=template&id=036a2072&"
import script from "./GlobalCouponDisplay.vue?vue&type=script&lang=js&"
export * from "./GlobalCouponDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports